// Client-side mirror of apps/server/src/modules/auth/password.ts: tells the
// user what is wrong before the form is sent. The server check is the one that counts.

export const PASSWORD_MIN_LENGTH = 10;

const OBVIOUS = new Set([
  'password',
  'password1',
  'password12',
  'password123',
  'password1234',
  'qwerty12345',
  'qwertyuiop',
  'qwerty123456',
  '1234567890',
  '12345678910',
  '0123456789',
  '0987654321',
  '1q2w3e4r5t',
  'administrator',
  'admin12345',
  'admin123456',
]);

/** Russian explanation of why the password is unacceptable, or null when it is fine. */
export function passwordProblem(password: string, email?: string | null): string | null {
  if (password.length < PASSWORD_MIN_LENGTH) return `Пароль должен быть не короче ${PASSWORD_MIN_LENGTH} символов`;
  const lower = password.toLowerCase();
  if (OBVIOUS.has(lower) || /^(.{1,4})\1+$/.test(lower)) return 'Слишком простой пароль — такой подбирают первым';
  const mail = email?.trim().toLowerCase();
  if (mail) {
    const local = mail.split('@')[0] ?? '';
    if (lower.includes(mail) || (local.length >= 4 && lower.includes(local))) {
      return 'Пароль не должен совпадать с email или содержать его';
    }
  }
  return null;
}
